import { render, staticRenderFns } from "./goods-info.vue?vue&type=template&id=e54b2428&scoped=true&"
import script from "./goods-info.vue?vue&type=script&lang=ts&"
export * from "./goods-info.vue?vue&type=script&lang=ts&"
import style0 from "./goods-info.vue?vue&type=style&index=0&id=e54b2428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54b2428",
  null
  
)

export default component.exports